export enum LocalStorageKeys {
    TOKEN_KEY = 'auth-token',
    REFRESH_KEY = 'auth-refesh-token',
    BREADCRUMB_KEY = 'breacrumb-items'
}